module.exports = __webpack_public_path__ + "img/lldxt.c0184840.png";